export enum AvailabilityStatus {
  Unavailable = "Unavailable",
  Available = "Available",
  PartiallyAvailable = "PartiallyAvailable",
}
